import React from 'react';
import { MapCarousel } from './MapCarousel';
import { mainProduct } from '../data/content';
export function MapProof() {
  return <section className="bg-night-panel" data-id="element-124" data-mp="2gmol3570vbw3">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" style={{
      paddingBottom: "0px"
    }} data-id="element-125" data-mp="2bp6n29ujmh2v">
        <div className="mx-auto max-w-2xl text-center" data-id="element-126" data-mp="27nur7ml2szm8">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "36px"
        }} data-id="element-127" data-mp="27pe91hmdriq4">
            {mainProduct.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-128" data-mp="2zfj182gdta1w">
            {mainProduct.description}
          </p>
        </div>

        <div className="mt-10" data-id="element-129" data-mp="2qmz1eyocszfh">
          <MapCarousel data-id="element-130" data-mp="2qlnskkg1x1hi" />
        </div>
      </div>
    </section>;
}